import { EnumHelper } from "@singularsystems/neo-core";

export enum enumFileDelimiter {
    Tab = "Tab",
    Semicolon = "Semicolon",
    Space = "Space",
    Comma = "Comma",
    Pipe = "Pipe"
}

// values that show on the UI dropdown
EnumHelper.decorateEnum(enumFileDelimiter, e => {
    e.describe(enumFileDelimiter.Tab, "Tab");
    e.describe(enumFileDelimiter.Semicolon, "Semicolon");
    e.describe(enumFileDelimiter.Space, "Space");
    e.describe(enumFileDelimiter.Comma, "Comma");
    e.describe(enumFileDelimiter.Pipe, "Pipe");
})